// import React from "react";
// import InputFactory from "../../../../../components/InputFactory";
// import { saveFileUseCase } from "../../../../../usecases/file";

// export default function RequestAccessModal({
//   onRequestAccessChange,
//   requestAccessObject,
// }) {
//   return (
//     <div>
//       <p className="fw-bold" style={{ fontSize: "1.2rem" }}>
//         Request Access
//       </p>
//       <div className="d-flex align-items-center gap-2">
//         <p className="m-0" style={{ width: "100%", fontSize: ".875rem" }}>
//           Reason for Unlocking:
//         </p>
//         <InputFactory
//           type="String"
//           field="reason"
//           onChange={onRequestAccessChange}
//           placeholder="Select Reason"
//           _type="Enum"
//           options={[
//             "Common Name",
//             "Dormant",
//             "Cancelled Previous Application",
//             "Declined",
//             "Others",
//           ]}
//         />
//       </div>
//       <div>
//         <p style={{ fontSize: ".875rem", paddingTop: ".6rem" }}>Remarks</p>
//         <textarea
//           className="form-control"
//           placeholder="Example"
//           onChange={(e) => onRequestAccessChange(e.target.value, "remarks")}
//           style={{
//             padding: ".7rem",
//             maxHeight: "12rem",
//             minHeight: "4rem",
//             height: "8rem",
//             fontSize: ".9rem",
//           }}
//         />
//       </div>
//       <div className="mb-3">
//         <label className="form-label fw-bold">File Attachment</label>
//         <InputFactory
//           className="col-9"
//           type="MultipleFile"
//           field="attachment"
//           saveFile={saveFileUseCase()}
//           onChange={(value, field) => onRequestAccessChange(value, field)}
//           placeholder="Enter Reason"
//           // required
//           multi={true}
//           multiple
//         />
//       </div>
//     </div>
//   );
// }

import React, { useState } from "react";
import InputFactory from "../../../../../components/InputFactory";
import { saveFileUseCase } from "../../../../../usecases/file";

export default function RequestAccessModal({
  onRequestAccessChange,
  requestAccessObject,
}) {
  // State to track the selected reason
  const [selectedReason, setSelectedReason] = useState("");

  // Handle reason change
  const handleReasonChange = (value) => {
    setSelectedReason(value);
    onRequestAccessChange(value, "reason"); // Update parent state
  };

  return (
    <div>
      <p className="fw-bold" style={{ fontSize: "1.2rem" }}>
        Request Access
      </p>

      <div className="d-flex align-items-center gap-2">
        <p className="m-0" style={{ width: "100%", fontSize: ".875rem" }}>
          Reason for Unlocking:
        </p>
        <InputFactory
          type="String"
          field="reason"
          onChange={handleReasonChange} // Use local state update function
          placeholder="Select Reason"
          _type="Enum"
          options={[
            "Common Name",
            "Dormant",
            "Cancelled Previous Application",
            "Declined",
            "Others",
          ]}
        />
      </div>

      <div>
        <p style={{ fontSize: ".875rem", paddingTop: ".6rem" }}>Remarks</p>
        <textarea
          className="form-control"
          placeholder="Example"
          onChange={(e) => onRequestAccessChange(e.target.value, "remarks")}
          style={{
            padding: ".7rem",
            maxHeight: "12rem",
            minHeight: "4rem",
            height: "8rem",
            fontSize: ".9rem",
          }}
        />
      </div>

      {/* Conditionally show File Attachment if selected reason is "Common Name" or "Dormant" */}
      {(selectedReason === "Common Name" ||
        selectedReason === "Dormant" ||
        selectedReason === "Cancelled Previous Application" ||
        selectedReason === "Declined" ||
        selectedReason === "Others") && (
        <div className="mb-3">
          <label className="form-label fw-bold">File Attachment</label>
          <InputFactory
            className="col-9"
            type="MultipleFile"
            field="attachment"
            saveFile={saveFileUseCase()}
            onChange={(value, field) => onRequestAccessChange(value, field)}
            placeholder="Enter Reason"
            multi={true}
            multiple
          />
        </div>
      )}
    </div>
  );
}
